namespace TabAurous.Production {
    export namespace WIPTransactionBagDepartmentWiseService {
        export const baseUrl = 'Production/WIPTransactionBagDepartmentWise';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<WIPTransactionRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Production/WIPTransactionBagDepartmentWise/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>WIPTransactionBagDepartmentWiseService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
